"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var wallet_adapter_react_1 = require("@solana/wallet-adapter-react");
var wallet_adapter_react_ui_1 = require("@solana/wallet-adapter-react-ui");
// Default styles that can be overridden by your app
require('@solana/wallet-adapter-react-ui/styles.css');
var Wallet = function () {
    var publicKey = (0, wallet_adapter_react_1.useWallet)().publicKey;
    var base58 = (0, react_1.useMemo)(function () { return publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58(); }, [publicKey]);
    (0, react_1.useMemo)(function () {
        if (base58 !== undefined) {
            setWalletId(base58);
        }
    }, [base58]);
    function setWalletId(id) {
        var wallet = document.getElementById("solanaWalletId");
        if (!wallet)
            return;
        wallet.value = id;
    }
    return (react_1.default.createElement("div", { className: "row justify-content-center" },
        react_1.default.createElement(wallet_adapter_react_ui_1.WalletMultiButton, null)));
};
exports.default = Wallet;
